import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Brand } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PinGate } from "@/components/PinGate";
import { ChildrenManager } from "@/components/ChildrenManager";
import { FamilyHistory } from "@/components/FamilyHistory";
import { getFamily } from "@/lib/family";
import { VoicePicker } from "@/components/VoicePicker";
import { GiveGoldenAcorn } from "@/components/GiveGoldenAcorn";
import { RewardsEditor } from "@/components/RewardsEditor";
import { FamilyMembers } from "@/components/FamilyMembers";
import { Nice } from "@/components/Nice";
import { GoldenCollection } from "@/components/GoldenCollection";
import { TeacherNotes } from "@/components/TeacherNotes";
import { GoldenNewBadge } from "@/components/GoldenNewBadge";

export default function Family() {
  const [family, setFamily] = useState(null);
  const [pin, setPin] = useState("");
  const reload = () => getFamily().then(setFamily);
  useEffect(() => { reload(); }, []);

  return (
    <div className="pp-app mode-kid" data-testid="family-page">
      <header className="pp-header">
        <Brand />
        <Link to="/" className="pp-ghost" data-testid="family-back-link"><ArrowLeft className="h-4 w-4" /> Back to <Nice /></Link>
      </header>
      <main className="pp-main pp-wide">
        <p className="pp-label">For parents · family area</p>
        <h1 className="pp-h1 flex flex-wrap items-center gap-3">Your family <GoldenNewBadge /></h1>
        <p className="pp-sub max-w-xl">Give each child their own name so you can see everyone's kind requests.</p>
        <Link to="/golden-acorns" className="pp-ghost mt-4" data-testid="family-guide-link">How golden acorns & rewards work</Link>
        <div className="mt-8 space-y-8">
          {family && !pin && <PinGate hasPin={family.has_pin} onUnlock={(p) => { setPin(p); reload(); }} />}
          {family && pin && (
            <>
              <ChildrenManager pin={pin} profiles={family.profiles} reload={reload} />
              <FamilyMembers pin={pin} />
              <GoldenCollection pin={pin} profiles={family.profiles} />
              <GiveGoldenAcorn pin={pin} profiles={family.profiles} />
              <TeacherNotes pin={pin} profiles={family.profiles} />
              <RewardsEditor pin={pin} profiles={family.profiles} />
              <FamilyHistory pin={pin} profiles={family.profiles} />
              <VoicePicker />
              <button className="pp-ghost" onClick={() => setPin("")} data-testid="lock-family-button">Lock family area</button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
